import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'
import { useFormikContext } from 'formik'

import { Box, TextField } from '@mui/material'
import { FormValuesSportsRO } from '@/views/sports-ro-calculator/hooks'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

export const MaxLineFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const { values } = useFormikContext<FormValuesSportsRO>()

  return (
    <Box mt={1}>
      <NumberFormat
        value={values.maxLine}
        name="maxLine"
        customInput={TextField}
        type="text"
        prefix=""
        label={t('restrictions.maxLine')}
        thousandSeparator=","
        onValueChange={({ value: v }) => {
          if (Number(v) > 0) {
            handleChangeSearch('maxLine', -v)
          } else {
            handleChangeSearch('maxLine', v)
          }
        }}
      />
    </Box>
  )
}
